__webpack_require__.p = "/PosManagerWeb/";